module.exports = __webpack_public_path__ + "img/forgot_password_top.2f4d2300.png";